/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youtube_Export_Link_LabelInputs */

const cs_youtube_export_link_label = /** @type {(inputs: Youtube_Export_Link_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popisek odkazu (volitelné)`)
};

const en_youtube_export_link_label = /** @type {(inputs: Youtube_Export_Link_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link label (optional)`)
};

/**
* | output |
* | --- |
* | "Link label (optional)" |
*
* @param {Youtube_Export_Link_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_link_label = /** @type {((inputs?: Youtube_Export_Link_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_Link_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_link_label(inputs)
	return cs_youtube_export_link_label(inputs)
});